module.exports = __webpack_public_path__ + "static/media/Chellelogo.a3f8d052.png";